<h3 mat-dialog-title>{{ "selectFieldsOnLabels" | translate }}</h3>

<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>{{ 'selectFields' | translate }}</mat-label>
      <mat-select panelClass="min-height-60vh" formControlName="fields" multiple>
        <mat-option *ngFor="let field of data.fields" [value]="field">
          {{ field.name | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="fieldsControl.hasError('required')">
        {{ 'required' | translate }}
      </mat-error>
      <mat-error *ngIf="fieldsControl.hasError('noRequiredField')">
        {{ 'requiredAnyOfFields' | translate : { fields: requiredFieldsNames } }}
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="fieldsControl.value" [disabled]="!form.valid">
    {{ "save" | translate }}
  </button>
  <button mat-button mat-dialog-close>
    {{ "cancel" | translate }}
  </button>
</mat-dialog-actions>